import robuxModule from '../robuxModule';
import purchaseWarningModalController from '../controllers/purchaseWarningModalController';

function robuxSubscriptionUpsellPackage(premiumService, premiumConstants, $uibModal) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      product: '=',
      isUpsell: '='
    },
    templateUrl: premiumConstants.templates.robuxSubscriptionUpsellPackage,
    link(scope) {
      scope.layout = {
        isPremiumUser: false
      };
      scope.upsellPackage = null;
      scope.$watch(
        function(scope) {
          return scope.$parent.robuxPageData.upsellPackage;
        },
        function(newVal, oldVal, scope) {
          if (scope.isUpsell && newVal) {
            scope.upsellPackage = newVal;
            scope.upsellPackage.isRecurring =
              scope.upsellPackage.subscriptionTypeName
                .toLowerCase()
                .indexOf(premiumConstants.premiumFeatureType.month) < 0;
          }
        }
      );

      scope.$watch(
        function(scope) {
          return scope.$parent.robuxPageData.userPlan;
        },
        function(newVal, oldVal, scope) {
          if (newVal) {
            scope.layout.isPremiumUser = newVal.hasOwnProperty('subscriptionTypeName');
          }
        }
      );

      scope.showPurchaseWarningModal = function(product) {
        if (scope.$parent.isPurchaseWarningModalEnabled) {
          $uibModal.open({
            templateUrl: premiumConstants.templates.purchaseWarningModal,
            controller: purchaseWarningModalController,
            resolve: {
              productType: product
            }
          });
        } else {
          const link = document.createElement('a');
          link.href = premiumService.getPurchaseUrl(product, premiumConstants.pageContext.robux);
          link.click();
        }
      };
    }
  };
}

robuxModule.directive('robuxSubscriptionUpsellPackage', robuxSubscriptionUpsellPackage);

export default robuxModule;
